<template>
  <add-distributor-payment-modal
    v-if="showAddPaymentModal"
    :invoice-summary="invoiceSelected"
    :close-popup="hidePaymentModal"
  />
  <dialogue-modal
    v-if="distributorInvoiceToDelete"
    title="Are you sure you want to delete?"
    :message="distributorInvoiceToDelete.reference"
    :close-popup="hideDeleteModal"
    :buttons="buttons"
  />
  <page-title pageTitle="Supplier Invoices" title="All Supplier Invoices" />

  <div class="row pb-4 gy-3 justify-content-between">
    <div class="col-sm-auto col-md">
      <div class="d-flex input-group">
        <label class="input-group-text" for="startDate"> Start Date </label>
        <DateInput v-model="startDate" @input="goToPage(1)" />
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="d-flex input-group">
        <label class="input-group-text" for="endDate"> End Date </label>
        <DateInput v-model="endDate" @input="goToPage(1)" />
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupSelect01">
          Supplier
        </label>
        <select
          class="form-select"
          id="inputGroupSelect01"
          v-model="supplier"
          @change="goToPage(1)"
          placeholder="All"
        >
          <option value="" selected>All</option>
          <option
            v-for="(value, key) in distributors"
            :key="key"
            :value="value.company"
          >
            {{ value.company }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="row pb-4 gy-3 justify-content-between">
    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupMonth">Month</label>
        <select
          class="form-select"
          id="inputGroupMonth"
          v-model="this.filterMonth"
          @change="goToPage(1)"
          placeholder="Choose..."
        >
          <option value="">Select a month...</option>
          <option
            v-for="month in months"
            :key="month.value"
            :value="month.value"
          >
            {{ month.label }}
          </option>
        </select>
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupYear">Year</label>
        <input
          type="text"
          class="form-control"
          id="inputGroupYear"
          v-model="this.filterYear"
          @change="goToPage(1)"
          placeholder="Year"
        />
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupSelect01">Status</label>
        <select
          class="form-select"
          id="inputGroupSelect01"
          v-model="this.status"
          @change="goToPage(1)"
          placeholder="Choose..."
        >
          <option value="" selected>All</option>
          <option class="text-bg-danger" value="DUE">DUE</option>
          <option class="text-bg-primary" value="PAID">PAID</option>
          <option class="text-bg-warning" value="REFUND">REFUND</option>
        </select>
      </div>
    </div>
  </div>

  <div class="row pb-4 gy-3 justify-content-between">
    <div class="col-sm-auto col-md">
      <router-link
        to="/distributors/invoices/new"
        class="btn btn-primary addtax-modal no-wrap"
      >
        <i class="las la-plus me-1"></i> Add New
      </router-link>
    </div>

    <div class="col-sm-auto col-md-8">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          id="searchMemberList"
          placeholder="Search for Result"
          v-model="searchQuery"
          @input="goToPage(1)"
        />
        <i class="las la-search search-icon"></i>
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupSelect01">Show</label>
        <select
          class="form-select"
          id="resultsPerPage"
          v-model="resultsPerPage"
          @change="goToPage(1)"
        >
          <option
            v-for="option in resultsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div v-if="data && data.length > 0">
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <table-component
              :headers="headers"
              :footer="footer"
              :data="formattedData"
              :actions="actions"
              :offset="(currentPage - 1) * resultsPerPage"
              @sort="goToPage"
            />
          </div>
        </div>
      </div>
    </div>
    <pagination-component
      :rows-loaded="data.length"
      :current-page="currentPage"
      :num-pages="numPages"
      :total-rows="totalRows"
      :go-to-page="goToPage"
    />
  </div>

  <div v-else class="row">
    <div class="col-xl-12">
      <div class="card">
        <LoadingModal v-if="loading" />
        <div v-else class="card-body">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import TableComponent from "@/components/utils/Table";
import { SETTINGS } from "@/constants/config.js";
import { CONSTANTS } from "@/constants/constants.js";
import LoadingModalComponent from "@/components/utils/LoadingModal";
import PaginationComponent from "@/components/utils/paginationComponent";
import DialogueModal from "@/components/utils/modals/DialogueModal";
import DateInput from "@/components/utils/DateInput";
import AddDistributorPaymentModal from "@/components/payment/AddDistributorPaymentModal";

export default {
  name: "AllDistributorInvoicesView",
  components: {
    AddDistributorPaymentModal,
    DialogueModal,
    PaginationComponent,
    LoadingModal: LoadingModalComponent,
    PageTitle: PageTitleComponent,
    TableComponent: TableComponent,
    DateInput: DateInput,
  },
  data() {
    return {
      searchQuery: "",
      startDate: "",
      endDate: "",
      filterMonth: "",
      filterYear: "",
      status: "",
      supplier: "",
      months: [
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
      ],
      resultsPerPage: SETTINGS.resultsPerPage,
      distributorInvoiceToDelete: null,
      invoiceSelected: null,
      showAddPaymentModal: false,
    };
  },
  computed: {
    headers() {
      return CONSTANTS.DISTRIBUTORS_INVOICES_HEADERS;
    },
    footer() {
      return [
        "",
        "",
        "",
        "",
        "Total",
        this.amountPurchaseTotal,
        this.amountPaidTotal,
        this.amountDueTotal,
        "",
        "",
        "",
        "",
      ];
    },
    data() {
      return this.$store.getters.allDistributorInvoices;
    },
    distributors() {
      return this.$store.getters.allDistributors;
    },
    formattedData() {
      const allDistributorInvoices = this.$store.getters.allDistributorInvoices;
      return allDistributorInvoices.map((distributorInvoice) => ({
        ...distributorInvoice,
        date: this.dateFormat(distributorInvoice.date),
        datePaid: distributorInvoice.datePaid
          ? this.dateFormat(distributorInvoice.datePaid)
          : distributorInvoice.datePaid,
      }));
    },
    amountPurchaseTotal() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data
        .reduce((total, item) => total + parseFloat(item.amountPurchase), 0)
        .toFixed(2);
    },
    amountPaidTotal() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data
        .reduce((total, item) => total + parseFloat(item.amountPaid), 0)
        .toFixed(2);
    },
    amountDueTotal() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data
        .reduce((total, item) => total + parseFloat(item.amountDue), 0)
        .toFixed(2);
    },
    currentPage() {
      return this.$store.getters.distributorInvoicesCurrentPage;
    },
    numPages() {
      return this.$store.getters.distributorInvoicesNumPages;
    },
    totalRows() {
      return this.$store.getters.distributorInvoicesTotalRows;
    },
    resultsPerPageOptions() {
      const options = CONSTANTS.RESULTS_PER_PAGE_OPTIONS;
      if (!options.includes(this.resultsPerPage)) {
        options.unshift(this.resultsPerPage);
      }
      return options;
    },
    actions() {
      return {
        View: (distributorInvoice) =>
          this.viewDistributorInvoice(distributorInvoice.id),
        Edit: (distributorInvoice) =>
          this.editDistributorInvoice(distributorInvoice.id),
        "Add Payment": (distributorInvoice) =>
          this.showPaymentModal(distributorInvoice),
        "View Payments": (distributorInvoice) =>
          this.viewPayments(distributorInvoice.id),
        Delete: (distributorInvoice) =>
          this.showDeleteModal(distributorInvoice),
      };
    },
    error() {
      return this.$store.getters.distributorInvoicesError;
    },
    loading() {
      return this.$store.getters.distributorInvoicesLoading;
    },
    buttons() {
      return {
        Yes: {
          class: "btn-danger",
          function: () => this.deleteDistributorInvoice(),
        },
        No: {
          class: "btn-light px-3",
          function: () => this.hideDeleteModal(),
        },
      };
    },
  },
  methods: {
    async goToPage(page, sortBy = null) {
      let filter = {
        sortingList: sortBy,
        currentPage: page,
        resultsPerPage:
          this.resultsPerPage === "ALL" ? this.totalRows : this.resultsPerPage,
        searchQuery: this.searchQuery,
        startDate: this.startDate,
        endDate: this.endDate,
        distributor: this.supplier,
        month: this.filterMonth,
        year: this.filterYear,
        status: this.status,
      };
      await this.$store.dispatch("getDistributorInvoices", filter);
      await this.$store.dispatch("getDistributors", {});
    },
    dateFormat(date) {
      let parts = date.split("-");
      let formattedDate = parts[1] + "-" + parts[2] + "-" + parts[0];
      return formattedDate;
    },
    viewDistributorInvoice(id) {
      this.$router.push("/distributors/invoices/" + id);
    },
    editDistributorInvoice(id) {
      this.$router.push("/distributors/invoices/edit/" + id);
    },
    viewPayments(id) {
      this.$router.push("/distributors/invoices/" + id + "/payments/");
    },
    showPaymentModal(invoice) {
      this.invoiceSelected = this.data.find((item) => item.id === invoice.id);
      this.invoiceSelected = {
        ...this.invoiceSelected,
        total: this.invoiceSelected.amountPurchase,
        balance: this.invoiceSelected.amountDue,
      };
      this.showAddPaymentModal = true;
    },
    hidePaymentModal() {
      this.invoiceSelected = null;
      this.showAddPaymentModal = false;
    },
    showDeleteModal(distributorInvoice) {
      this.distributorInvoiceToDelete = distributorInvoice;
    },
    async deleteDistributorInvoice() {
      if (this.distributorInvoiceToDelete) {
        await this.$store.dispatch(
          "deleteDistributorInvoice",
          this.distributorInvoiceToDelete.id
        );
        await this.goToPage(1);
        this.hideDeleteModal();
      } else {
        alert("There has been an error");
      }
    },
    hideDeleteModal() {
      this.distributorInvoiceToDelete = null;
    },
  },
  async created() {
    let filter = {
      resultsPerPage: SETTINGS.resultsPerPage,
    };
    await this.$store.dispatch("getDistributorInvoices", filter);
    filter = {
      resultsPerPage: 100,
    };
    await this.$store.dispatch("getDistributors", filter);
  },
  async beforeUnmount() {
    await this.$store.dispatch("resetDistributorInvoices");
  },
};
</script>

<style scoped></style>
